__turbopack_context__.v({
  "getStartedButton": "styles-module-scss-module__XYnWrW__getStartedButton",
});
